import axios from 'axios';
import jwtDecode from 'jwt-decode';

import { API_ODIN_ACCOUNT_URL, PACE_API_HOSTS } from 'src/constants';

import { appEnvControl } from 'utils';

import { sessionStore } from 'stores';

export type OdinAccountUpdate = Partial<{
  firstname: string;
  lastname: string;
  birthdate: string;
  gender: string;
  nationality: string;
  country: string;
  street: string;
  city: string;
  postCode: string;
}>;

const odinApi = axios.create();
odinApi.defaults.headers.common = {};

class OdinAccount {
  isOdinSession(): boolean {
    const token = sessionStore.session.token;

    if (!token) {
      return false;
    }

    try {
      return 'cognito:username' in (jwtDecode(token) as AnyObject);
    } catch {
      return false;
    }
  }

  async update(account: OdinAccountUpdate): Promise<boolean> {
    if (!this.isOdinSession()) {
      return false;
    }

    const url = `${PACE_API_HOSTS[appEnvControl.currentEnvWithDefaultDev()]}${API_ODIN_ACCOUNT_URL}`;

    try {
      await odinApi.patch(url, account, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStore.session.token}`,
        },
      });

      return true;
    } catch (error) {
      console.error('Odin account update request failed:', error);
      return false;
    }
  }
}

const odinAccountService = new OdinAccount();

export { OdinAccount, odinAccountService };
